/** 降级记录：只读列出 `GET /degradations`。后端无产出方时如实空态，不造样例。 */

import { Card, Lede, Note, PageHead } from "../../components/Card";
import { Pill } from "../../components/Pill";
import { Table } from "../../components/Table";
import { rehearsalSummary, useDegradations } from "../../lib/channels";
import { ScreenState } from "../p2/Common";

export function DegradationScreen(): React.ReactNode {
  const rows = useDegradations();
  return (
    <>
      <PageHead title="降级记录" sub="只读 · GET /degradations" />
      <Lede>历次切换与降级记录，由内核写下、服务端原样列出，本屏不推断哪次算降级。</Lede>
      <ScreenState query={rows} what="降级记录（GET /degradations）">
        {(data) => (
          <>
            <Note>{rehearsalSummary(data)}</Note>
            {data.some((r) => r.result === "in_progress") ? <Note tone="warn">降级进行中，见通道管理屏</Note> : null}
            <Card title="记录表" nopad>
              <Table
                cols={[
                  { label: "编号", mono: true },
                  { label: "开始", mono: true },
                  { label: "类型" },
                  { label: "性质" },
                  { label: "从 → 到", mono: true },
                  { label: "触发", wrap: true },
                  { label: "结果" },
                  { label: "告警" },
                  { label: "降级后对账", mono: true },
                ]}
                empty="尚无切换或降级记录。现阶段只有纸上盘自撮合一条通道，没有外部托管在用（真通道待 D4 实盘通道裁决）。"
                rows={data.map((r) => ({
                  key: r.id,
                  cells: [
                    r.id,
                    r.ts_utc,
                    r.kind,
                    r.nature,
                    `${r.from_channel_id ?? "—"} → ${r.to_channel_id ?? "—"}`,
                    r.trigger ?? "—",
                    <Pill tone={r.result === "ok" ? "ok" : r.result === "failed" ? "bad" : "warn"}>{r.result}</Pill>,
                    r.alert_id ?? <Pill tone="bad">缺</Pill>,
                    r.reconciliation_run_id ? (
                      `${r.reconciliation_run_id}${r.balanced_after === null ? "" : r.balanced_after ? " · 平" : " · 不平"}`
                    ) : (
                      <Pill tone="bad">缺</Pill>
                    ),
                  ],
                }))}
              />
            </Card>
          </>
        )}
      </ScreenState>
    </>
  );
}
